import '../scss/footer.scss'


// WEBPACK FOOTER //
// ./cms_plugins/footer/js/index.js